import { wait } from '@/__mocks__/util/async.ts'
import { status } from '@/__mocks__/config.ts'
import {
  supplierCatalog,
  supplierPage
} from '@/__mocks__/modules/suppliers/data.ts'

export default [
  {
    method: 'GET',
    path: '/suppliers/catalog',
    reply: async () => {
      await wait()
      return [status.ok, supplierCatalog]
    }
  },
  {
    method: 'GET',
    path: '/suppliers',
    reply: async () => {
      await wait()
      return [status.ok, supplierPage]
    }
  },
  {
    method: 'POST',
    path: '/suppliers/1/assign-models',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
